// NPM Imports
import React, { Component } from "react";
import queryString from "query-string";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import PropTypes, { object } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader } from "@revvsales/components";
import * as stringSanitizer from "string-sanitizer";

// CSS Imports
import signupQesWrapper from "./signupqeswrapper.module.scss";

// Components Imports
import OrgCreationForm from "./OrgCreationForm/index";

// Services imports
import {
  popDemoDocument,
  signupUserService,
  trailSignupService,
  slackService,
} from "../../../AuthService/authService";

// Methods imports
import { redirectPostAuthentication } from "../../../AuthService/authMethods";

// Internal Imports
import ASSET_BG from "../../../assets/asset-bg.png";
import DOC_BG from "../../../assets/doc-bg.png";
import { AUTH } from "../../../constants";
import { GlobalUtils } from "../../../utils";

// Destructuring
const { GOOGLE_BASED_AUTH, PASSWORD_BASED_AUTH } = AUTH;
const {
  readDataFromLocalStorage,
  removeDataFromLocalStorage,
  readCookie,
  removeCookie,
  setUserCookies,
} = GlobalUtils;

// Declaration
const docToPopExists = readCookie("revv_doc_no");
const SIGNUP_BG_IMG = docToPopExists ? DOC_BG : ASSET_BG;

export default class SignupQesWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // org creation form fields
      email: "",
      fname: "",
      lname: "",
      password: "",
      orgName: "",
      allowUserToJoin: true,
      errMsg: "",
      loader: false,
      // signup popup screens related fields
      showOrgCreationForm: false,
      isConversionReq: false,
    };
  }

  componentDidMount() {
    if (this.props.isInviteSignup) {
      const { formData } = this.props;
      this.setState({
        showOrgCreationForm: true,
        email: formData.email,
        fname: formData.fname,
        lname: formData.lname,
      });
    } else {
      const { search } = window.location;
      const queryParams = queryString.parse(search);

      const { suggestion, formData } = this.props;
      const orgName = suggestion ? suggestion.name : "";
      if (orgName) {
        this.setState({
          allowUserToJoin: true,
          showOrgCreationForm: true,
          orgName,
          email: formData.email,
          fname: formData.fname,
          lname: formData.lname,
        });
      } else {
        this.setState({
          showOrgCreationForm: true,
          orgName,
          email: formData.email,
          fname: formData.fname,
          lname: formData.lname,
        });
      }
      if (
        typeof queryParams === "object" &&
        Object.keys(queryParams).length > 0 &&
        queryParams.phone !== undefined
      ) {
        const paramObj = {
          isConversionReq: true,
          companySize: queryParams.size ? queryParams.size : "",
          workTitle: queryParams.title ? queryParams.title : "",
          phoneNumber: queryParams.phone ? queryParams.phone : "",
          fname: queryParams.fname ? queryParams.fname : "",
          lname: queryParams.lname ? queryParams.lname : "",
        };
        if (orgName.length === 0) {
          paramObj.orgName = queryParams.company;
        }
        this.setState(paramObj);
      }
    }
  }

  // form input field change handler
  _inputChangeHandler = e => {
    if (e.target.name === "allowUserToJoin") {
      this.setState(prevState => ({
        allowUserToJoin: !prevState.allowUserToJoin,
      }));
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  _onSelectChange = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  _handleOrgCreationForm = () => {
    const { fname, lname, password, orgName } = this.state;
    const firstName = fname.trim();
    const lastName = lname.trim();
    // Check if mobile no is valid
    this.setState({ errMsg: "" });
    if (this.props.signupMethod === GOOGLE_BASED_AUTH) {
      if (this.props.isInviteSignup) {
        if (!firstName || !lastName) {
          this.setState({
            errMsg: "All fields are mandatory!",
          });
        } else {
          this._submitSignupInfo();
          // this.setState({
          //   showOrgCreationForm: false,
          // });
        }
      } else if (!firstName || !lastName || !orgName) {
        this.setState({
          errMsg: "All fields are mandatory!",
        });
      } else {
        this._submitSignupInfo();
      }
    } else if (this.props.signupMethod === PASSWORD_BASED_AUTH) {
      if (this.props.isInviteSignup) {
        if (!password || !firstName || !lastName) {
          this.setState({
            errMsg: "All fields are mandatory!",
          });
        } else if (password.length < 6) {
          this.setState({
            errMsg: "Password should be of minimum 6 characters.",
          });
        } else {
          this._submitSignupInfo();
        }
      } else if (!password || !firstName || !lastName || !orgName) {
        this.setState({
          errMsg: "All fields are mandatory!",
        });
      } else if (password.length < 6) {
        this.setState({
          errMsg: "Password should be of minimum 6 characters.",
        });
      } else {
        this._submitSignupInfo();
      }
    }
  };

  // This is only for testing purpose,
  // will revert it in future
  _submitSignupInfo = role => {
    const { fname, lname, password, orgName, allowUserToJoin } = this.state;
    // consider space is a valid use case
    const withoutSpaceFname = stringSanitizer.removeSpace(fname);
    const withoutSpaceLname = stringSanitizer.removeSpace(lname);

    if (
      !stringSanitizer.validate.isUsername(withoutSpaceFname) ||
      !stringSanitizer.validate.isUsername(withoutSpaceLname)
    ) {
      this.setState({
        errMsg:
          "Please enter a first and last name without any special characters",
      });
    } else {
      let payload = {};

      // User signup in case of invite case
      if (this.props.isInviteSignup && !this.props.isOneClickInvite) {
        const inviteSignupMethod = this.props.signupMethod;
        if (inviteSignupMethod === GOOGLE_BASED_AUTH) {
          payload.auth_type = "google";
          payload.google_response = {
            id_token: this.props.formData.googleToken,
            first_name: this.props.formData.fname,
            last_name: this.props.formData.lname,
            email_id: this.props.formData.email,
            invitation_token: this.props.formData.inviteToken,
            signup_info: {
              user_role: role,
            },
            org_domain: this.props.formData.subDomain || "",
          };
        } else if (inviteSignupMethod === PASSWORD_BASED_AUTH) {
          payload.auth_type = "password";
          payload.user = {
            user_email: this.props.formData.email,
            password: this.state.password,
            first_name: this.state.fname.trim(),
            last_name: this.state.lname.trim(),
            token: this.props.formData.inviteToken,
            signup_info: {
              user_role: role,
            },
          };
        }
        this._inviteUserSignup(payload);
      }

      // User signup in case of one click invite
      else if (this.props.isInviteSignup && this.props.isOneClickInvite) {
        const inviteSignupMethod = this.props.signupMethod;
        if (inviteSignupMethod === GOOGLE_BASED_AUTH) {
          payload.auth_type = "google";
          payload.invite_code = this.props.formData.oneClickInviteToken;
          payload.google_response = {
            id_token: this.props.formData.googleToken,
            first_name: this.props.formData.fname,
            last_name: this.props.formData.lname,
            email_id: this.props.formData.email,
            signup_info: {
              user_role: role,
            },
            org_domain: this.props.formData.subDomain || "",
          };
        } else if (inviteSignupMethod === PASSWORD_BASED_AUTH) {
          payload.auth_type = "password";
          payload.invite_code = this.props.formData.oneClickInviteToken;
          payload.user = {
            user_email: this.props.formData.email,
            password: this.state.password,
            first_name: this.state.fname.trim(),
            last_name: this.state.lname.trim(),
            signup_info: {
              user_role: role,
            },
          };
        }
        this._inviteUserSignup(payload);
      }
      // User signup in case of normal case
      else {
        const {
          formData: { email, tokenId, utmTerm } = {},
          signupMethod,
          suggestion,
        } = this.props;
        payload = {
          name: orgName,
          suggestion,
          auto_provisioning: allowUserToJoin,
        };
        // update the payload, if the sign up method is 'password' based
        if (signupMethod === PASSWORD_BASED_AUTH) {
          payload.auth_type = "password";
          payload.user = {
            first_name: fname.trim(),
            last_name: lname.trim(),
            user_email: email,
            password,
            signup_info: {
              ...utmTerm,
              user_role: role,
            },
          };
          if (this.state.isConversionReq) {
            const ph =
              formatPhoneNumberIntl(this.state.phoneNumber) ||
              this.state.phoneNumber;
            payload.user.signup_info = {
              ...payload.user.signup_info,
              phone_number: ph,
              work_title: this.state.workTitle,
              company_size: this.state.companySize,
            };
          }
        }
        // update the payload, if the sign up method is 'google' based
        if (signupMethod === GOOGLE_BASED_AUTH) {
          payload.auth_type = "google";
          payload.google_response = {
            id_token: tokenId,
            first_name: fname,
            last_name: lname,
            email,
            signup_info: {
              ...utmTerm,
              user_role: role,
            },
            org_domain: this.props.formData.subDomain || "",
          };
        }

        const referral = readDataFromLocalStorage("referral");
        if (referral && referral.length > 0) {
          payload.referral = referral;
          payload.user.signup_info = {
            ...payload.user.signup_info,
            referral,
          };
        }
        this._normalUserSignup(payload);
      }
    }
  };

  _inviteUserSignup = payload => {
    this.setState({ loader: true });
    signupUserService(payload)
      .then(response => {
        // remove the 'signupOrgID' from localStorage which was added
        // in 'indentifyUserFromInvitationToken'
        removeDataFromLocalStorage("signupOrgID");
        if (response && response.subdomain) {
          let method;
          const data = {};
          if (this.props.signupMethod === GOOGLE_BASED_AUTH) {
            method = "gmail_invite";
            const {
              signup_info: { user_role: userRole },
            } = payload.google_response;
            data.onboardingUserRole = userRole;
          } else if (this.props.signupMethod === PASSWORD_BASED_AUTH) {
            method = "email_invite";
            const {
              signup_info: { user_role: userRole },
            } = payload.user;
            data.onboardingUserRole = userRole;
          }
          // SET FLAG TO DETERMINE USER LANDED FROM SIGNUP/SIGNIN PAGE
          response.redirectedFromSignup = true;

          setUserCookies(response);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "signupsuccessevent",
            category: "SignupSuccess",
            action: "formsubmit",
            value: "Formsubmitcompleted",
          });
          // Pop the document if user tried in the document playground
          popDemoDocument()
            .then(docData => {
              redirectPostAuthentication(response, docData, {
                flow: "signup",
                params: { method },
              });
            })
            .catch(() => {
              redirectPostAuthentication(response, null, {
                flow: "signup",
                params: { method },
              });
            });
        } else {
          this.setState({
            loader: false,
            errMsg: "Something went wrong. Please try again!",
          });
        }
      })
      .catch(error => {
        console.error(`SignUp => _signUpUser => ${error}`);
        this.setState({ loader: false });

        if (error.response.status === 400) {
          if (this.props.isOneClickInvite) {
            this.setState({
              loader: false,
              errMsg:
                "This invite link is incorrect. Please get the right link.",
            });
          } else {
            this.setState({ loader: false, errMsg: "Invalid Signup Details." });
          }
        } else if (error.response.status === 409) {
          this.setState({
            loader: false,
            errMsg:
              "An account with this email already exists. Sign-in instead.",
          });
        } else {
          this.setState({
            loader: false,
            errMsg: "Something went wrong. Please try again!",
          });
        }
      });
  };

  _normalUserSignup = payload => {
    this.setState({ loader: true });
    trailSignupService(payload, this.props.formData.plan)
      .then(async response => {
        if (response && response.subdomain) {
          let method;
          // setting the 'user data' in cookie & redirect
          const data = {};
          if (this.props.signupMethod === GOOGLE_BASED_AUTH) {
            method = "gmail";
            const {
              signup_info: { user_role: userRole, company_size: cmpSize },
            } = payload.google_response;
            data.onboardingUserRole = userRole;
            if (cmpSize) {
              data.companySize = cmpSize;
            }
          } else if (this.props.signupMethod === PASSWORD_BASED_AUTH) {
            method = "email";
            const {
              signup_info: { user_role: userRole, company_size: cmpSize },
            } = payload.user;
            data.onboardingUserRole = userRole;
            if (cmpSize) {
              data.companySize = cmpSize;
            }
          }

          // removing cookies after sign up
          removeCookie("SubCategoryName");
          removeCookie("CategoryName");
          removeCookie("TemplateName");
          removeCookie("InitiatedFrom");
          // remove utm params from localstorage
          removeCookie("utmParams");
          // SET FLAG TO DETERMINE USER LANDED FROM SIGNUP/SIGNIN PAGE
          response.redirectedFromSignup = true;
          setUserCookies(response);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "signupsuccessevent",
            category: "SignupSuccess",
            action: "formsubmit",
            value: "Formsubmitcompleted",
          });
          // Pop the document if user tried in the document playground
          const slackAuthentication = slackService(response);
          const retainDemoDocument = popDemoDocument();
          await Promise.all([slackAuthentication, retainDemoDocument])
            .then(res => {
              const docData = res[1];
              redirectPostAuthentication(response, docData, {
                flow: "signup",
                params: { method },
              });
            })
            .catch(() => {
              redirectPostAuthentication(response, null, {
                flow: "signup",
                params: { method },
              });
            });
        } else {
          this.setState({
            loader: false,
            errMsg: "Something went wrong. Please try again!",
          });
        }
      })
      .catch(err => {
        console.error(`_normalUserSignup => trailSignupService => ${err}`);
        this.setState({
          loader: false,
          errMsg: "Something went wrong. Please try again!",
        });
      });
  };

  // eslint-disable-next-line class-methods-use-this
  _getFormErrorMessage = errorMessage => {
    let errMsgSpace = null;
    if (errorMessage) {
      errMsgSpace = (
        <div className={signupQesWrapper.errorMessageWrapper}>
          <span className={signupQesWrapper.errorMessageWrapper}>
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {errorMessage}
        </div>
      );
    }
    return errMsgSpace;
  };

  _decideSignupQesModal = () => {
    const {
      errMsg,
      email,
      fname,
      lname,
      orgName,
      password,
      allowUserToJoin,
      showOrgCreationForm,
    } = this.state;
    const { suggestion, signupMethod, isInviteSignup } = this.props;
    const errMessage = this._getFormErrorMessage(errMsg);

    if (showOrgCreationForm) {
      return (
        <OrgCreationForm
          errMessage={errMessage}
          email={email}
          fname={fname}
          lname={lname}
          password={password}
          orgName={orgName}
          isInviteSignup={isInviteSignup}
          allowUserToJoin={allowUserToJoin}
          suggestion={suggestion}
          signupMethod={signupMethod}
          inputChangeHandler={this._inputChangeHandler}
          handleOrgCreationForm={this._handleOrgCreationForm}
          onSelectChange={this._onSelectChange}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <div className={signupQesWrapper.trailPopupWrapper}>
        <div className={signupQesWrapper.trailBackgroundScreen}>
          <img
            src={SIGNUP_BG_IMG}
            alt="Revv"
            className={signupQesWrapper.trailBackgroundImg}
          />
        </div>
        <Modal
          open
          onClose={() => {}}
          center
          showCloseIcon={false}
          classNames={{ modal: "revvModalContainer" }}>
          {this.state.loader && (
            <div className={signupQesWrapper.accountSetupScreen}>
              <div>
                <div className={signupQesWrapper.accLoaderWrapper}>
                  <Loader />
                </div>
                <div className={signupQesWrapper.settingText}>
                  Preparing your account for liftoff{" "}
                  <span role="img" aria-label="rocket">
                    🚀
                  </span>
                </div>
              </div>
            </div>
          )}
          {this._decideSignupQesModal()}
        </Modal>
      </div>
    );
  }
}

SignupQesWrapper.defaultProps = {
  isInviteSignup: undefined,
  suggestion: object,
  isOneClickInvite: false,
};

SignupQesWrapper.propTypes = {
  signupMethod: PropTypes.string.isRequired,
  isInviteSignup: PropTypes.string,
  isOneClickInvite: PropTypes.bool,
  suggestion: PropTypes.shape({
    fjoin: PropTypes.bool,
    name: PropTypes.string,
    pe_domain: PropTypes.bool,
    sub_domain: PropTypes.string,
  }),
  formData: PropTypes.shape({
    companySize: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    email: PropTypes.string.isRequired,
    fname: PropTypes.string.isRequired,
    lname: PropTypes.string.isRequired,
    plan: PropTypes.string.isRequired,
    tokenId: PropTypes.string.isRequired,
    password: PropTypes.string,
    token: PropTypes.string,
    signupMethod: PropTypes.string,
    inviteToken: PropTypes.string,
    oneClickInviteToken: PropTypes.string,
    googleToken: PropTypes.string,
    utmTerm: PropTypes.shape({
      utm_term: PropTypes.string,
    }),
    orgName: PropTypes.string,
    subDomain: PropTypes.string,
  }).isRequired,
};
